"use strict";
exports.__esModule = true;
exports.isBase64ImageUri = exports.calculateAspectRatio = void 0;
var regexes_1 = require("../regexes");
var calculateAspectRatio = function (width, height) {
    return width / height;
};
exports.calculateAspectRatio = calculateAspectRatio;
var isBase64ImageUri = function (value) {
    if (typeof value === 'string') {
        return regexes_1.base64UriValidationRegex.test(value);
    }
    return false;
};
exports.isBase64ImageUri = isBase64ImageUri;
